var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterHnWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    viewBox: "93 512 923.5 152.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill: #FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1008.3,512 944.7,512 1008.3,589.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "793,571.4 793,513.6 747.4,513.6 747.4,661.6 793,661.6 793,613.8 844.4,571.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1016.5,660.3 901.9,514.4 901.4,514.8 901.4,513.6 855.8,513.6 855.8,661.6 901.4,661.6 901.4,588.8    955.9,660.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.9,556.3c-5.9,0-11.7,0.8-17.4,2.4s-11.8,4-18.2,7.3c-2.9-3.3-6.5-5.7-11-7.3s-9.1-2.4-13.9-2.4   c-4.1,0-8.1,0.7-11.8,2c-3.8,1.3-8.2,3.4-13.3,6.3v-5.8H93v102.9h27.6v-76.9l2.5-0.8c5.8-1.9,10.8-2.9,15.2-2.9   c4.2,0,7.4,0.9,9.6,2.6c2.1,1.7,3.6,4.5,4.3,8.3c0.8,3.8,1.1,9.5,1.1,16.9v52.9h27.6v-53.3c0-6.5-0.3-14.3-0.8-23.5l3.1-1   c6.6-1.9,11.9-2.9,15.8-2.9c5.6,0,9.5,2,11.5,6s3.1,10.6,3.1,19.8v54.9h27.6v-55.7c0-17.4-2.7-30-8-37.8S218.7,556.3,205.9,556.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.1,640.6c-0.9-1.2-1.5-3.6-1.8-7v-42.8c0-12.1-2.9-20.8-8.7-26.3c-5.8-5.5-15.3-8.2-28.5-8.2   c-13.2,0-27.1,2-42,6l0.8,19.1c5.3-0.4,12-0.8,20-1.1s14.2-0.5,18.7-0.5c4.4,0,7.5,0.8,9.4,2.5c1.9,1.7,2.8,4.5,2.8,8.6v6.4   l-22,1.7c-12.6,0.8-21.8,3.6-27.5,8.3c-5.7,4.7-8.5,12.4-8.5,23.1c0,22.5,10.6,33.7,31.9,33.7c10.2,0,20.2-2.4,30.2-7.2   c4.1,2.9,8.3,4.8,12.4,5.8s9.8,1.4,17,1.4l0.8-20.8C348.7,642.7,347,641.8,346.1,640.6z M316.8,638.4l-3.1,0.8   c-6.2,1.6-11.9,2.5-17.1,2.5c-6.7,0-10.1-3.8-10.1-11.3c0-7.5,3.8-11.7,11.5-12.3l18.7-1.7V638.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.8,608.6c-4.7-4.3-12.5-7.6-23.5-9.8l-7.2-1.2c-6.2-1.1-10.6-2.2-13.4-3.4s-4.1-3.2-4.1-6.1   c0-2.7,1.3-4.6,4-5.5c2.7-1,6.3-1.4,11-1.4c8,0,20.2,1.1,36.8,3.3l0.4-22.8l-6.8-1.2c-14.4-2.6-25.3-3.9-32.7-3.9   c-12.5,0-22.3,2.8-29.4,8.4c-7.1,5.6-10.7,14.3-10.7,25.9c0,7.3,1.4,12.9,4.1,17c2.8,4,6.3,7,10.7,8.8c4.4,1.8,10,3.4,16.9,4.6   c1,0.3,2.7,0.5,5.1,0.8c6.6,1.1,11.3,2.3,14.1,3.5c2.8,1.2,4.2,3.2,4.2,6c0,3-1.5,5.1-4.4,6.2c-3,1.1-7,1.7-12,1.7   c-7.5,0-19.6-1.1-36.2-3.3l-0.8,23l6.6,1.2c13,2.5,24.1,3.7,33.1,3.7c14,0,24.3-2.8,31.1-8.4c6.7-5.6,10.1-14.3,10.1-26.1   C447.8,619.9,445.5,613,440.8,608.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.1,639.4c-3.8,0.1-6.2-1-7.2-3.4c-1-2.4-1.4-6.3-1.4-11.6v-42.2h25.3v-23.5h-25.3v-28.6h-27.6v28.6h-12.1   v23.5h12.1V625c0,9.9,1,17.6,2.9,23.2c1.9,5.6,5.1,9.7,9.5,12.1c4.4,2.5,10.6,3.7,18.5,3.7c3.2,0,6.3-0.2,9.4-0.6s7.4-1.2,12.9-2.5   l-1.2-22L508.1,639.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.6,556.3c-15.8,0-27.4,4.7-34.9,14c-7.5,9.3-11.2,23.5-11.2,42.4c0,18.1,3.6,31.2,10.7,39.3   c7.1,8.1,18.7,12.1,34.8,12.1c12.2,0,26-1.9,41.5-5.8l-0.4-20.4l-5.8,0.6c-2.9,0.3-7.5,0.5-13.8,0.8c-6.3,0.3-11.7,0.4-16.2,0.4   c-5.8,0-10.2-0.5-13.5-1.5c-3.2-1-5.5-2.8-7-5.3c-1.4-2.5-2.3-6.2-2.6-11h60.5l2.1-19.1c0-15.5-3.7-27.1-11.2-34.9   C609.1,560.2,598.1,556.3,583.6,556.3z M565.1,600.9c0.1-7.9,1.6-13.6,4.3-17c2.7-3.4,7.4-5,14-5c6.4,0,10.9,1.6,13.5,4.8   c2.5,3.2,3.8,8.9,3.8,17.2H565.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M674.9,558.8h-27.4v102.9h27.6v-68.9l4.1-1.4c8.8-2.7,18.3-5.1,28.6-7.2v-27.8c-10.1,2.1-21.1,6.5-32.9,13.4   V558.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterHnWhite);
export default __webpack_public_path__ + "static/media/MasterHN-white.f69edb2a731e4f5824dd74104911a314.svg";
export { ForwardRef as ReactComponent };